import { createBrowserClient } from "@supabase/ssr";

const MISSING_SUPABASE_ENV_ERROR = "Missing NEXT_PUBLIC_SUPABASE_URL or NEXT_PUBLIC_SUPABASE_ANON_KEY.";

function isPublicE2ETestModeEnabled(): boolean {
    return process.env.NEXT_PUBLIC_E2E_TEST_MODE === "1";
}

function createE2EBrowserClientMock(): ReturnType<typeof createBrowserClient> {
    return {
        auth: {
            getUser: async () => ({ data: { user: null }, error: null }),
            getSession: async () => ({ data: { session: null }, error: null }),
            signOut: async () => ({ error: null }),
        },
    } as unknown as ReturnType<typeof createBrowserClient>;
}

export function createClient() {
    if (isPublicE2ETestModeEnabled()) {
        return createE2EBrowserClientMock();
    }

    const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
    const anonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;
    if (!url || !anonKey) {
        throw new Error(MISSING_SUPABASE_ENV_ERROR);
    }

    return createBrowserClient(
        url,
        anonKey
    );
}
